import { useMemo } from 'react';
import textAdditionalClassName from '../../../helpers/utils/TextAdditionalClassName';

interface BodySmallProps {
  children: React.ReactNode;
  className?: string;
  maxLines?: number;
  isClamp?: boolean;
  style?: React.CSSProperties;
  textBreak?: 'words' | 'characters';
  overflow?: 'hidden' | 'visible';
}

const BodySmall = ({
  children,
  maxLines = 2,
  isClamp = false,
  className = '',
  style = {},
  textBreak = 'words',
  overflow = 'hidden',
  ...props
}: BodySmallProps & React.ComponentProps<'p'>) => {
  const lineClampStyle: React.CSSProperties = isClamp
    ? {
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
      }
    : {};

  const additionalClassName = useMemo(
    () => textAdditionalClassName(textBreak, overflow),
    [textBreak, overflow]
  );

  return (
    <p
      style={{ ...lineClampStyle, ...style }}
      className={`text-[12px] leading-[16px] text-black90  ${additionalClassName} ${className} `}
      {...props}
    >
      {children}
    </p>
  );
};

export default BodySmall;
